import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SearchIndexTypeState {
  searchIndexType: string;
}

const initialState: SearchIndexTypeState = {
  searchIndexType: 'itinerary',
};

const searchIndexTypeSlice = createSlice({
  name: 'searchIndexTypeState',
  initialState,
  reducers: {
    setSearchIndexType: (state, action: PayloadAction<string>) => {
      state.searchIndexType = action.payload;
    },
  },
});

export const { setSearchIndexType } = searchIndexTypeSlice.actions;
export default searchIndexTypeSlice.reducer;
